import { ArExperienceChoices } from '@/constants';
import { Image } from './api';

export enum PoiState {
    LOCKED,
    READY_TO_UNLOCK,
    UNLOCKED
}

export interface Coordinates {
    latitude: number;
    longitude: number;
}

export interface PoiText {
    id: number;
    title: string;
    text: string;
    audio: string;
}

export interface PoiLink {
    id: number;
    text: string;
    url: string;
}

export interface PoiContent {
    caption: string;
    aspect: string;
}

export interface PoiImage extends PoiContent {
    image: Image;
}

export interface PoiAudio extends PoiContent {
    image: Image;
    audio: string;
}

export interface PoiVideo extends PoiContent {
    preview: Image;
    video: string;
}

export interface PanoImage {
    default: string;
}

export interface PoiPanorama extends PoiContent {
    preview: Image;
    panorama: PanoImage;
}

export interface PoiArExperience extends PoiContent {
    preview: Image;
    experience: ArExperienceChoices;
    fallback: string;
    onboarding: string;
}

export interface Poi {
    id: number;
    number: number;
    title: string;
    coordinates: Coordinates;
    route: number;
    community: string;
    is_special: boolean;
    obstructions: string;
    created: Date;
    modified: Date;
    texts: PoiText[];
    links: PoiLink[];
    topics: any[];
    sponsors: any[];
    content_images: PoiImage[];
    content_audios: PoiAudio[];
    content_videos: PoiVideo[];
    content_panoramas: PoiPanorama[];
    content_ar_experiences: PoiArExperience[];

    // Custom fields
    state: PoiState;
    distance: number; // In meters
}

// Logfile entry of POI state events
export interface PoiJournalEntry {
    time: Date;
    poi_id: number;
    old_state: PoiState;
    new_state: PoiState;
    position: number[];
}
